<template>
  <div class="f-col gap-4">
    <define-sign-in-option v-slot="{ icon, label, description }">
      <button
        class="flex items-center gap-3 rounded-xs bg-grey-90 p-4 "
        :class="brandClasses.signInOption"
        :style="brandStyles?.signInOption"
      >
        <vf-icon :name="icon" size="lg" />
        <div>
          <span class="fw-bold">{{ label }}</span>
          <p v-if="description" :class="brandClasses.signInOptionDescription">
            {{ description }}
          </p>
        </div>
        <vf-icon class="ml-a" name="chevron" size="lg" />
      </button>
    </define-sign-in-option>

    <vf-notification v-if="passkeyError" type="error">
      {{ $t.mfa.passkeyError }}
    </vf-notification>

    <sign-in-option
      v-if="lookupData.authMethods.includes('passkey')"
      :description="$t.mfa.passkeyDescription"
      icon="key"
      :label="$t.mfa.passkey"
      @click="signInWithPasskey"
    />
    <sign-in-option
      v-if="lookupData.authMethods.includes('mfa')"
      icon="chat"
      :label="$t.mfa.getCode"
      @click="selectOption('mfa', EnrollmentState.VERIFICATION_OPTIONS)"
    />
    <sign-in-option
      v-if="lookupData.authMethods.includes('password')"
      icon="lock"
      :label="$t.mfa.password"
      @click="selectOption('password', EnrollmentState.SIGNIN_PASSWORD)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { LookupData } from '#root/api/clients/consumer/data-contracts'
import type { FormLocation } from '#types/gtm'
import type { IconName } from '#types/icon'
import { EnrollmentState } from '#root/enums/profile'

const { lookupData, formLocation = 'modal:single:none:none' } = defineProps<{ lookupData: LookupData, formLocation?: FormLocation }>()

const emit = defineEmits<{
  continue: [state: EnrollmentState]
  resolve: []
}>()

const [DefineSignInOption, SignInOption] = createReusableTemplate<{
  icon: IconName
  label: string
  description?: string
}>()

const { $gtm } = useNuxtApp()
const { brandClasses, brandStyles } = useAppConfig().components.dialog.simplifiedEnrollment

const passkeyError = ref(false)

const selectOption = (method: LookupData['authMethods'][number], nextState: EnrollmentState) => {
  $gtm.push('authForm.onLoginOptionSelected', 'Gateway', method, formLocation)
  emit('continue', nextState)
  passkeyError.value = false
}

const { signInWithPasskey } = usePasskey(lookupData.email, {
  onContinue: (state) => selectOption('passkey', state),
  onError: () => { passkeyError.value = true },
  onSuccess: () => emit('resolve'),
  formLocation
})
</script>
